import { useEffect, useState } from "react";

export const StatusCircle = ({ status, width, height, fontSize }) => {
  const [style, setStyle] = useState(null);
  const [symbol, setSymbol] = useState(null);
  
  useEffect(() => {
    const failure = { color: "#721c24", backgroundColor: "#f8d7da", border: "1px solid #f5c6cb" };
    const success = { color: "#155724", backgroundColor: "#d4edda", border: "1px solid #c3e6cb" };
    const darkSuccess = { color: "white", backgroundColor: "#038164" };
    const darkFailure = { color: "white", backgroundColor: "#721c24" };

    const constStyle = { width: width || 80, height: height || 80, borderRadius: "50%", fontSize: fontSize || "2.5rem" };
    if (status === "dark-success") {
      setStyle({...darkSuccess, ...constStyle});
      setSymbol("✔");
    } else if (status === "dark-failure") {
      setStyle({...darkFailure, ...constStyle});
      setSymbol("✖");
    } else if (status === "success") {
      setStyle({...success, ...constStyle});
      setSymbol("✔");
    } else if (status === "failure") {
      setStyle({...failure, ...constStyle});
      setSymbol("✖");
    }
  }, [status, width, height, fontSize]);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={style}
    >
      {symbol}
    </div>
  );
};
